import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
import { Seo } from '../components/Seo';
import { Eyebrow, Heading, NextPage, Section, TextLink } from '../components/ui';
import { resourceCategories, resourceCount } from '../data/resources';
import { socials } from '../data/site';
export function Bronnen() {
  return <>
      <Seo title="Bronnen & vermeldingen | LeonDesign lederwaren Geleen" description="Overzicht van bedrijfsprofielen, Nederlandse vermeldingen, kaartdiensten en zakelijke platforms waarop LeonDesign uit Geleen te vinden is." data-id="element-94" data-mp="25b5zmwbeql44" />

      <Section className="pt-12 sm:pt-16" data-id="element-95" data-mp="1rc673dkrxm2o">
        <div className="max-w-3xl" data-id="element-96" data-mp="1rczac4kixtg2">
          <Eyebrow data-id="element-97" data-mp="1re0wb432w0ck">Bronnen</Eyebrow>
          <h1 className="font-display text-4xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-5xl" data-id="element-98" data-mp="1mdmqlsoy92hp">
            Waar LeonDesign nog meer online te vinden is
          </h1>
          <p className="mt-6 text-lg leading-relaxed text-cocoa/90" data-id="element-99" data-mp="3grduebklks58">
            Onderstaand overzicht bundelt {resourceCount} externe vermeldingen van LeonDesign,
            geordend per soort platform. Zo kunt u de bedrijfsgegevens ook buiten deze site
            controleren, of het bedrijf terugvinden via de gids die u zelf gebruikt.
          </p>
          <p className="mt-4 text-[17px] leading-relaxed text-cocoa/85" data-id="element-100" data-mp="3px56akevy0fg">
            Zoekt u liever direct informatie over het aanbod? Begin dan bij de{' '}
            <TextLink to="/collectie" data-id="element-101" data-mp="mebw8hlbftq1">collectiepagina</TextLink> of ga terug naar de{' '}
            <TextLink to="/" data-id="element-102" data-mp="re6n4l53cjb3">homepage</TextLink>.
          </p>
        </div>

        <nav aria-label="Categorieën op deze pagina" className="mt-8" data-id="element-103" data-mp="rfhq4iqppn15">
          <ul className="flex flex-wrap gap-2" data-id="element-104" data-mp="coil1hp35gmb">
            {resourceCategories.map(c => <li key={c.id} data-id="element-105" data-mp="hmaon8z3er6c">
                <a href={`#${c.id}`} className="inline-block rounded-full border border-cocoa/20 px-4 py-2 text-[15px] font-medium text-cocoa transition-colors duration-150 ease-out hover:border-pine hover:text-pine" data-id="element-106" data-mp="hliv03p233ip">
                  {c.title}
                </a>
              </li>)}
          </ul>
        </nav>
      </Section>

      <Section className="pt-14" data-id="element-107" data-mp="1ez8zpbb0u8h3">
        <div className="space-y-16" data-id="element-108" data-mp="1a17fuo5ru54k">
          {resourceCategories.map(category => <section key={category.id} id={category.id} className="scroll-mt-24 border-t border-cocoa/15 pt-10" data-id="element-109" data-mp="160wyyggfxuax">
              <div className="max-w-2xl" data-id="element-110" data-mp="1133ubrusd8cr">
                <Heading data-id="element-111" data-mp="waan8xbuhnxi">{category.title}</Heading>
                <p className="mt-3 text-[16px] leading-relaxed text-cocoa/85" data-id="element-112" data-mp="w8hhrlcyx9r3">{category.intro}</p>
              </div>

              <ul className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-113" data-mp="mceicn9i3p7u">
                {category.items.map(item => <li key={item.href} className="flex flex-col rounded-2xl border border-cocoa/12 bg-paper p-5" data-id="element-114" data-mp="ibb0jv7w7j3z">
                    <h3 className="font-display text-lg font-semibold text-ink" data-id="element-115" data-mp="de2hztiu1d27">{item.name}</h3>
                    <p className="mt-2 flex-1 text-[15px] leading-relaxed text-cocoa/85" data-id="element-116" data-mp="2p1ecctvol73m">
                      {item.description}
                    </p>
                    <a href={item.href} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 text-[15px] font-medium text-pine underline decoration-pine/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-cocoa hover:decoration-cocoa" data-id="element-117" data-mp="2y0t37ufrfjon">
                      {item.anchor}
                      <ExternalLinkIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-118" data-mp="2f75ncg5uzwa7" />
                    </a>
                  </li>)}
              </ul>
            </section>)}

          <section id="sociaal" className="scroll-mt-24 border-t border-cocoa/15 pt-10" data-id="element-119" data-mp="1miqkes0054f8">
            <div className="max-w-2xl" data-id="element-120" data-mp="1rhl0hm6l4evn">
              <Heading data-id="element-121" data-mp="3u5tf9sjh6bnb">Officiële sociale kanalen</Heading>
              <p className="mt-3 text-[16px] leading-relaxed text-cocoa/85" data-id="element-122" data-mp="3u48kq2x5uspg">
                Dit zijn de sociale profielen van LeonDesign zelf. Hier verschijnen nieuwe modellen,
                foto’s van het assortiment en berichten over horeca lederwaren.
              </p>
            </div>
            <ul className="mt-8 flex flex-wrap gap-3" data-id="element-123" data-mp="218xv7jr4nhy">
              {socials.map(s => <li key={s.href} data-id="element-124" data-mp="gplp5r7w9i64">
                  <a href={s.href} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full border border-cocoa/20 px-5 py-2.5 text-[15px] font-medium text-cocoa transition-colors duration-150 ease-out hover:border-pine hover:text-pine" data-id="element-125" data-mp="bsltma8o7xt9">
                    {s.label}
                    <ExternalLinkIcon className="h-4 w-4" aria-hidden="true" data-id="element-126" data-mp="2ni61ufc08p8u" />
                  </a>
                </li>)}
            </ul>
          </section>
        </div>
      </Section>

      <Section className="pt-16" data-id="element-127" data-mp="2hg2pe3psutyn">
        <div className="grid gap-4 md:grid-cols-3" data-id="element-128" data-mp="2he9j4pj3mbr6">
          <NextPage to="/" label="Terug naar de homepage" description="Introductie op LeonDesign, de productgroepen en het leerspecialisme." data-id="element-129" data-mp="23oeeg3raebj9" />
          <NextPage to="/over-ons" label="Over LeonDesign" description="Achtergrond, productfilosofie en de klantgroepen die bediend worden." data-id="element-130" data-mp="1tpym5xgiww86" />
          <NextPage to="/contact" label="Contact & locatie" description="Telefoon, e-mail, adres in Geleen en de kaartweergave van de vestiging." data-id="element-131" data-mp="1ymp1giki7nsj" />
        </div>
      </Section>
    </>;
}